import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import useGetUser from "../../../hooks/useGetUser";
import { useDispatch } from "react-redux";
import { SignOut } from "../../../store/reducers/auth.reducer";
import { getQueryParamByName } from "../../../utils/getQueryParamByName";
import t from "../../../i18n/i18n";

import "./styles.css";

export const HeaderProfile = () => {
  useGetUser();
  const dispatch = useDispatch();
  const isMobile = useMemo(() => {
    const size = getQueryParamByName("size");

    if (size === "mobile") {
      return true;
    } else {
      return false;
    }
  }, []);

  const { logged } = useSelector((store) => store.auth);
  const { user } = useSelector((store) => store.auth);

  const logout = () => {
    dispatch(SignOut());
    window.parent.postMessage({ action: "logout" }, "*");
  };

  useEffect(() => {
    if (!logged) {
      window.parent.postMessage({ action: "logged-out" }, "*");
    }
  }, [logged]);

  return (
    <div className={`header-menu-container`}>
      {logged && (
        <>
          {!isMobile && (
            <>
              <a href={t("Config.MainSite")} target="_parent">
                <span className="icon">
                  <img src="/images/game-icon.png" alt="" />
                </span>
              </a>
              <Link to={process.env.REACT_APP_IframeHeader_RechargeCenterLink} target="_parent">
                <div className="icon">
                  <img src="/images/doller-icon.png" alt="" />
                </div>
              </Link>
              <Link to={process.env.REACT_APP_IframeHeader_LoyalMemberLink} target="_parent">
                <div className="icon">
                  <img src="/images/crown-icon.png" alt="" />
                </div>
              </Link>
              <Link to={process.env.REACT_APP_IframeHeader_SupportLink} target="_parent">
                <div className="icon">
                  <img src="/images/face-icon.png" alt="" />
                </div>
              </Link>
            </>
          )}
          <div className="personal-info-container">
            <div className="personal-info">
              <img src={user?.avatar || "/images/user-thumn-m.png"} alt="Avatar" />
              <p>{user?.nickname}</p>
            </div>
            <div className="logout cursor-pointer" onClick={logout}>
              <img src="/images/sair-icon.png" alt="Logout" />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default HeaderProfile;
